window.Visualizations.Tables.AjaxTableBidsList = {
  rerender: function (htmlID, newHtml) {
    const element = document.getElementById(htmlID);
    if (element) element.innerHTML = newHtml;
  }
};
